<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <ion-list>
    <ion-item>
      <ion-label floating>
        @if (formErrors.has('phone')) {
          <span color="danger"><br />{{formErrors.get('phone')}}</span>
        }
      </ion-label>
      <ion-input formControlName="phone" type="text" [placeholder]="phonePlaceHolder"></ion-input>
    </ion-item>
  </ion-list>

  <div padding>
    <ion-button type="submit" [disabled]="!form.valid" ion-button color="primary" expand="block">
      {{ 'Account.Update' | translate }}
    </ion-button>
  </div>
</form>